/* eslint-disable */
export default {
    myProducts: [],
    filteredProducts: [],
    myCategories: [],
    update: new Date(),
    singleProduct: {},
}